import dem from '../../content/places/arenal/geo/dem.json'
import { ANCHORS, METERS_PER_UNIT, worldToLatLon } from './geo'
import { isInsideLake } from './lakeMask'

const values = dem.values as number[]

export const WATER_ELEVATION_METERS = 540
export const WATER_Y = WATER_ELEVATION_METERS / METERS_PER_UNIT

export function sampleElevationMeters(x: number, z: number): number {
  const { lat, lon } = worldToLatLon(x, z)
  const u = Math.min(
    1,
    Math.max(0, (lon - dem.bounds.west) / (dem.bounds.east - dem.bounds.west)),
  )
  const v = Math.min(
    1,
    Math.max(0, (dem.bounds.north - lat) / (dem.bounds.north - dem.bounds.south)),
  )
  const gx = u * (dem.width - 1)
  const gy = v * (dem.height - 1)
  const x0 = Math.floor(gx)
  const y0 = Math.floor(gy)
  const x1 = Math.min(dem.width - 1, x0 + 1)
  const y1 = Math.min(dem.height - 1, y0 + 1)
  const tx = gx - x0
  const ty = gy - y0
  const a = values[y0 * dem.width + x0]!
  const b = values[y0 * dem.width + x1]!
  const c = values[y1 * dem.width + x0]!
  const d = values[y1 * dem.width + x1]!
  const top = a + (b - a) * tx
  const bottom = c + (d - c) * tx
  return top + (bottom - top) * ty
}

/** Real elevation with the same scale on horizontal and vertical axes. */
export function sampleHeight(x: number, z: number): number {
  if (isInsideLake(x, z)) return WATER_Y - 0.08
  return sampleElevationMeters(x, z) / METERS_PER_UNIT
}

export function volcanoSummit(): { x: number; y: number; z: number } {
  return {
    x: ANCHORS.peak.x,
    y: sampleHeight(ANCHORS.peak.x, ANCHORS.peak.z),
    z: ANCHORS.peak.z,
  }
}

export const DEM = dem
